export const supportedLanguageHeader = ['es'];
